import { render, staticRenderFns } from "./DeparturesPageV2.vue?vue&type=template&id=31aac16f"
import script from "./DeparturesPageV2.vue?vue&type=script&lang=js"
export * from "./DeparturesPageV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports